import ExcelJS from 'exceljs';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import DetectorController, { DeviceTotalType } from '../../../../controller/DetectorController';

export const useTotalDevice = () => {
  const [deviceTotal, setDeviceTotal] = useState<DeviceTotalType[]>([]);
  const [totalIsOpen, setTotalIsOpen] = useState<boolean>(false);

  const [dataLoading, setDataLoading] = useState<boolean>(true);

  const [dateType, setDateType] = useState<number>(0);
  const [date, setDate] = useState<Date>(new Date());

  const getDeviceTotal = async () => {
    try {
      const oParams = {
        type: dateType === 1 ? 'month' : 'day',
        date: moment(date).format('yyyy-MM-DD'),
      };
      setDataLoading(true);
      const response = await DetectorController.getDeviceTotal(oParams);

      if (response && response.data) {
        setDeviceTotal(response.data.data);
        setDataLoading(false);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const excelDownloadClick = () => {
    if (deviceTotal) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('기기 상태');

      // 헤더 추가
      worksheet.addRow(['순차', ...tableHeader]);

      // 데이터 행 추가
      deviceTotal.forEach((item: DeviceTotalType, index: number) => {
        worksheet.addRow([
          index + 1,
          item.store_name,
          item.count,
          item.unregistered_room_count,
          item.normal_count,
          item.alltime_count,
          item.checkin_count,
          item.checkout_count,
          item.abnormal_count,
          item.over_inactive_count,
        ]);
      });

      // 합계 행 추가
      worksheet.addRow([
        '',
        '합계',
        totals.count,
        totals.unregistered_room_count,
        totals.normal_count,
        totals.alltime_count,
        totals.checkin_count,
        totals.checkout_count,
        totals.abnormal_count,
        totals.over_inactive_count,
      ]);

      // 파일 저장
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `호텔 기기 내역_${getDateTitle()}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    }
  };

  // 날짜명 지정
  const getDateTitle = () => {
    if (dateType === 1) {
      return moment(date).format('yyyy년 MM월');
    } else return moment(date).format('yyyy-MM-DD');
  };

  useEffect(() => {
    getDeviceTotal();
  }, [dateType, date]);

  const tableHeader = [
    '호텔명',
    '전체',
    '미설치',
    '정상',
    '상시',
    '입실',
    '공실',
    '비정상',
    '장기 미응답',
  ];
  const totals = deviceTotal?.reduce(
    (acc, data) => {
      acc.count += data.count || 0;
      acc.unregistered_room_count += data.unregistered_room_count || 0;
      acc.normal_count += Number(data.normal_count) || 0;
      acc.alltime_count += data.alltime_count || 0;
      acc.checkin_count += data.checkin_count || 0;
      acc.checkout_count += data.checkout_count || 0;
      acc.abnormal_count += Number(data.abnormal_count) || 0;
      acc.over_inactive_count += data.over_inactive_count || 0;
      return acc;
    },
    {
      count: 0,
      unregistered_room_count: 0,
      normal_count: 0,
      alltime_count: 0,
      checkin_count: 0,
      checkout_count: 0,
      abnormal_count: 0,
      over_inactive_count: 0,
    },
  );

  return {
    deviceTotal,
    totalIsOpen,
    dateType,
    date,
    dataLoading,
    tableHeader,
    totals,
    setTotalIsOpen,
    setDateType,
    setDate,
    getDateTitle,
    excelDownloadClick,
  };
};
